import { action, createRequestTypes } from 'utils/actions'

export const SIGNUP_REQUEST = createRequestTypes('SIGNUP_REQUEST')
export const signupRequest = {
  request: () => action(SIGNUP_REQUEST.REQUEST),
  success: response => action(SIGNUP_REQUEST.SUCCESS, { response }),
  failure: error => action(SIGNUP_REQUEST.FAILURE, { error }),
}

export const SIGNUP_START = 'SIGNUP_START'
export const signupStart = () => action(SIGNUP_START)

export const SIGNUP_SUBMIT = 'SIGNUP_SUBMIT'
export const signupSubmit = data => action(SIGNUP_SUBMIT, { data })



/** WEBPACK FOOTER **
 ** ./src/actions/signup/signup-actions.js
 **/